module.exports = __webpack_public_path__ + "img/img_crm_order_link.95845ee1.svg";